module.exports = __webpack_public_path__ + "img/moneys-checked.2f009262.svg";